
import Login from './views/login'
import ForgotPasswordInit from './views/forgot_password_init'
import ForgotPassword from './views/forgot_password'
import FAQ from './views/FAQ'
import AsyncAppStart from './views/account/asyncAppStart'
import Shop from './views/shop'
import Product from './views/product'
import Cart from './views/shop/cart'
import Checkout from './views/shop/checkout'
import DeliveryMap from './views/delivery_map'
import Ordersuccess from './views/shop/order-success'
import Orderhistory from './views/account/order-history'
import Appstore from './views/account/appstore'
import Settings from './views/account/settings'
import Register1 from './views/account/register1'
import Register2 from './views/account/register2'
import Register3 from './views/account/register3'
import Register4 from './views/account/register4'
import Survey from './views/account/survey'
import Terms from './views/account/terms'
import Register_verify from './views/account/register_verify'
import Home from './views/home'
import UploadDocs from './views/account/uploadDocs'
import Rewards from './views/account/rewards'
import viewAll from './views/shop/viewAll'

let routes = [

  {
    path: '/account/register1',
    name: 'register1',
    component: Register1,
    meta: { requiresLogin: false, transition: 'slide-left' },
  },
  {
    path: '/account/terms',
    name: 'terms',
    component: Terms,
    meta: { requiresLogin: false }
  },
  {
    path: '/FAQ',
    name: 'FAQ',
    component: FAQ,
    meta: { requiresLogin: false }
  },
  {
    path: '/account/register2',
    name: 'register2',
    component: Register2,
    meta: { requiresLogin: false, transition: 'slide-left' },
  },
  {
    path: '/account/register3',
    name: 'register3',
    component: Register3,
    meta: { requiresLogin: false, transition: 'slide-left' },
  },
  {
    path: '/account/register4',
    name: 'register4',
    component: Register4,
    meta: { requiresLogin: false, transition: 'slide-left' },
  },
  {
    path: '/account/survey',
    name: 'survey',
    component: Survey,
    meta: { requiresLogin: true},
  },
  {
    path: '/account/register_verify',
    name: 'register_verify',
    component: Register_verify,
    meta: { requiresLogin: false },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    props: true,
    meta: { requiresLogin: false },
  },
  {
    path: '/forgot_password',
    name: 'forgot_password',
    component: ForgotPassword,
    props: true,
    meta: { requiresLogin: false },
  },
  {
    path: '/forgot_password_init',
    name: 'forgot_password_init',
    component: ForgotPasswordInit,
    meta: { requiresLogin: false },
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { requiresLogin: false },
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: { requiresLogin: false },
  },
  {
    path: '/appstart',//app version and sign in web
    name: 'appstart',
    redirect: { path: '/account/asyncAppStart' },
    meta: { requiresLogin: false },
  },
  {
    path: '/account/asyncAppStart',
    name:'asyncappstart',
    component: AsyncAppStart,
    meta: { requiresLogin: false },
  },
  {
    path:'/account/upload_docs',
    name: 'upload_docs',
    component: UploadDocs,
    // meta: { requiresLogin: true }, // todo: while testing no login for now
    meta: { requiresLogin: false, transition: 'slide-left' },
  },
  {
    path:'/account/appstore',
    name: 'appstore',
    component: Appstore,
    meta: { requiresLogin: false },
  },
  {
    path: '/shop',
    name: 'shop',
    component: Shop,
    meta: { requiresLogin: false }, // for cartid stuff w/o login
  },
  {
    path:'/product/sidebar/:id',
    name: 'product',
    component: Product,
    meta: { requiresLogin: false },
  },
  {
    path: '/shop/viewAll/:id',
    name: 'viewAll',
    component: viewAll,
    meta: {requiresLogin: false}
  },
  {
    path:'/shop/cart',
    name: 'cart',
    component: Cart,
    meta: { requiresLogin: false },
  },
  {
    path:'/shop/checkout',
    name: 'checkout',
    component: Checkout,
    meta: { requiresLogin: false }, // possible w/o login, order button is blocked
  },
  {
    path:'/delivery_map',
    name: 'delivery_map',
    component: DeliveryMap,
    meta: { requiresLogin: true },
  },
  {
    path:'/account/rewards',
    name: 'rewards',
    component: Rewards,
    meta: { requiresLogin: true },
  },
  {
    path:'/shop/order-success',
    name: 'ordersuccess',
    component: Ordersuccess,
    meta: { requiresLogin: true },
  },
  {
    path:'/account/order-history',
    name: 'orderhistory',
    component: Orderhistory,
    meta: { requiresLogin: true },
  },
  {
    path:'/account/settings',
    name: 'settings',
    component: Settings,
    meta: { requiresLogin: true },
  },

];

export default routes;
